import { Component, OnInit,Input,TemplateRef } from '@angular/core';

@Component({
  selector: 'chartsdiv',
  templateUrl: './chartsdiv.component.html',
  styleUrls: ['./chartsdiv.component.css']
})
export class ChartsdivComponent implements OnInit {

  @Input() sets;
  @Input() nzBlock: TemplateRef<void>;

  constructor() { }

  ngOnInit() {
  }

}
